<div style="background: url('assets/images/bg.jpg');" class="fixed left-0 top-0 min-h-screen min-w-screen"></div>

<!-- Toast for error messages -->
<p-toast position="top-right" key="toast" />

<div class="px-5 min-h-screen flex justify-content-center align-items-center">
  <div style="box-shadow: 3px 2px 33px -17px rgba(0,0,0,0.75);" class="border-1 surface-border surface-card border-round py-7 px-4 md:px-7 z-1">
    <div class="mb-4">
      <img src="assets/images/png/logo.png" width="150" alt="CogwheelMarketing Logo">
    </div>
    <div class="mb-4">
      <div class="text-900 text-xl font-bold mb-2">Forgot Password</div>
      <span class="text-600 font-medium">Enter your email to reset your password</span>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="requestPasswordReset()">
      <div class="flex flex-column">
        <p-fluid>
          <div class="w-full md:w-25rem mb-4">
            @for (message of messages(); track message; let first = $first) {
              <p-message [severity]="message.severity" [text]="message.content" styleClass="mb-3" closable/>
            }

            <p-iconfield>
              <p-inputicon>
                  <i class="pi pi-envelope"></i>
              </p-inputicon>
              <input id="email" type="email" formControlName="email" pInputText class="w-full" placeholder="Email" (input)="onEmailInput($event)" >
            </p-iconfield>

            <small
              *ngIf="control('email').invalid &&
                   (control('email').dirty || control('email').touched)"
              id="email-help" class="p-error w-full">
              <ng-container *ngIf="control('email').hasError('required')">
                Email is required.
              </ng-container>
              <ng-container *ngIf="control('email').hasError('email')">
                Please enter a valid email.
              </ng-container>

              <ng-container *ngIf="control('email').hasError('emailNotFound')">
                This email not found.
              </ng-container>
            </small>

            <small *ngIf="control('email')?.pending" id="email-checking" class="text-600 block mt-2">
              <i class="pi pi-spin pi-spinner mr-1"></i>
              Checking email...
            </small>
          </div>
        </p-fluid>
          <div class="flex flex-wrap gap-2 justify-content-between">
            <p-button
              type="button"
              label="Cancel"
              styleClass="w-full"
              class="flex-auto"
              [outlined]="true"
              [routerLink]="['/login']">
            </p-button>

            <p-button
              type="submit"
              label="Submit"
              styleClass="w-full"
              class="flex-auto"
              [loading]="loading"
              [disabled]="formGroup.invalid">
            </p-button>
          </div>
      </div>
    </form>
  </div>
</div>
